// Aligned with CPC Adyen checkout — single source for the allowed character set
const ALLOWED_CHARS = "A-Za-z~`_,'.\\s-";

export const CARD_HOLDER_NAME_PATTERN = new RegExp(`^[${ALLOWED_CHARS}]+$`);
